import {
    ADMIN_NOTIFICATION_FETCH_PENDING,
    ADMIN_NOTIFICATION_SELECT_GROUP,
    ADMIN_NOTIFICATION_UPDATE
} from '../../actions/admin/actionAdminNotification';
import get from 'get-value';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const adminNotification = (state = {isLoading: true, emailData: {}, selectedCountryGroup: ''}, action) => {
    switch (action.type) {
        case ADMIN_NOTIFICATION_FETCH_PENDING:
            return Object.assign({}, state, {isLoading: true, emailData: {}});
        case ADMIN_NOTIFICATION_UPDATE: {
            return Object.assign({}, state, {isLoading: true, emailData: {}});
        }
        case ADMIN_NOTIFICATION_SELECT_GROUP: {
            return Object.assign({}, state, {selectedCountryGroup: action.payload});
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_NOTIFICATIONS_SEND:
        case techDocWebsocketCommands.TECH_DOC_NOTIFICATIONS_SEND:
        case claimsWebsocketCommands.CLAIMS_NOTIFICATIONS_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                emailData: get(action, 'payload.notification', {default: {}}),
                correlationId
            });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_NOTIFICATIONS_ERROR:
        case techDocWebsocketCommands.TECH_DOC_NOTIFICATIONS_ERROR:
        case claimsWebsocketCommands.CLAIMS_NOTIFICATIONS_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_NOTIFICATIONS_SEND_ERROR:
        case techDocWebsocketCommands.TECH_DOC_NOTIFICATIONS_SEND_ERROR:
        case claimsWebsocketCommands.CLAIMS_NOTIFICATIONS_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoading: false, emailData: {}, correlationId});
        }
        default:
            return state;
    }
};

